import Header from "components/Headers/Header";
import React from "react";
import { Card, CardBody, Col, Container, Row, ListGroup, ListGroupItem } from "reactstrap";

const SharedResponsibility = () => {
  return (
    <>
      <Header />
      <Container fluid className="mt--4">
        {/* Main Header Banner */}
        <Card className="shadow border-0 rounded-4 overflow-hidden mb-4">
          <div className="bg-gradient-primary p-4 text-white">
            <span className="text-uppercase tracking-wider font-weight-600 text-white-50" style={{ fontSize: "10px", letterSpacing: "1.5px" }}>
              COMMUNITY GUIDELINES
            </span>
            <h2 className="text-white mb-0 mt-1 font-weight-700">
              A Shared Responsibility
            </h2>
            <p className="text-white-50 mb-0 mt-2 font-weight-500" style={{ fontSize: "1rem", lineHeight: "1.6" }}>
              All Users of FHP must understand that the system operates best in a condition of <strong>SHARED RESPONSIBILITY</strong>.
            </p>
          </div>
        </Card>

        {/* Content Section: 3 Columns for 3 Areas */}
        <Row className="d-flex align-items-stretch">
          
          {/* Card 1: School IP Contracts */}
          <Col lg="4" className="mb-4">
            <Card className="shadow-sm border-0 rounded-4 h-100 bg-white">
              <CardBody className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-3">
                    <span 
                      className="d-flex align-items-center justify-content-center rounded-circle mr-2"
                      style={{ width: "40px", height: "40px", backgroundColor: "#f0f3ff", color: "#5e72e4" }}
                    >
                      <i className="fas fa-file-contract" style={{ fontSize: "16px" }}></i>
                    </span>
                    <h4 className="text-dark font-weight-700 mb-0" style={{ fontSize: "0.95rem" }}>
                      ATHLETES & ADVISORS
                    </h4>
                  </div>
                  <h3 className="h4 text-primary font-weight-700 mb-3" style={{ lineHeight: "1.4" }}>
                    Validity of School IP Contracts
                  </h3>
                  <p className="text-muted mb-4" style={{ fontSize: "0.85rem" }}>
                    Cooperating to verify and sort out the validity of educational/school intellectual property contracts.
                  </p>
                  
                  <ListGroup className="list-group-flush">
                    {[
                      "Athlete contacts Advisor and asks for help.",
                      "Advisor contacts the School; School Official's reply proves or disproves validity of the contract.",
                      "Advisor alerts the Athlete of the result."
                    ].map((step, idx) => (
                      <ListGroupItem key={idx} className="border-0 px-0 py-2 d-flex align-items-start bg-transparent">
                        <i className="fas fa-check-circle text-primary mr-2 mt-1" style={{ fontSize: "13px" }}></i>
                        <span className="text-dark font-weight-500" style={{ fontSize: "0.875rem", lineHeight: "1.4" }}>
                          {step}
                        </span>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </div>
              </CardBody>
            </Card>
          </Col>

          {/* Card 2: Athlete Identities */}
          <Col lg="4" className="mb-4">
            <Card className="shadow-sm border-0 rounded-4 h-100 bg-white">
              <CardBody className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-3">
                    <span 
                      className="d-flex align-items-center justify-content-center rounded-circle mr-2"
                      style={{ width: "40px", height: "40px", backgroundColor: "#f0fdf4", color: "#2dce89" }}
                    >
                      <i className="fas fa-user-shield" style={{ fontSize: "16px" }}></i>
                    </span>
                    <h4 className="text-dark font-weight-700 mb-0" style={{ fontSize: "0.95rem" }}>
                      FANS & ATHLETES
                    </h4>
                  </div>
                  <h3 className="h4 text-success font-weight-700 mb-3" style={{ lineHeight: "1.4" }}>
                    Validity of Athlete Identities
                  </h3>
                  <p className="text-muted mb-4" style={{ fontSize: "0.85rem" }}>
                    Cooperating to ensure registered users are verified and expected athletes.
                  </p>
                  
                  <ListGroup className="list-group-flush">
                    {[
                      "Fans view an Athlete's Profile video to discern if the registered person is the expected Athlete.",
                      "If a question arises, Fans request a Zoom or Skype video call with the Athlete.",
                      "Fans in the video call verify or disprove the identity of the Athlete."
                    ].map((step, idx) => (
                      <ListGroupItem key={idx} className="border-0 px-0 py-2 d-flex align-items-start bg-transparent">
                        <i className="fas fa-check-circle text-success mr-2 mt-1" style={{ fontSize: "13px" }}></i>
                        <span className="text-dark font-weight-500" style={{ fontSize: "0.875rem", lineHeight: "1.4" }}>
                          {step}
                        </span>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </div>
              </CardBody>
            </Card>
          </Col>

          {/* Card 3: NIL Laws & Regulations */}
          <Col lg="4" className="mb-4">
            <Card className="shadow-sm border-0 rounded-4 h-100 bg-white">
              <CardBody className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <div className="d-flex align-items-center mb-3">
                    <span 
                      className="d-flex align-items-center justify-content-center rounded-circle mr-2"
                      style={{ width: "40px", height: "40px", backgroundColor: "#fff0f6", color: "#fb6340" }}
                    >
                      <i className="fas fa-gavel" style={{ fontSize: "16px" }}></i>
                    </span>
                    <h4 className="text-dark font-weight-700 mb-0" style={{ fontSize: "0.95rem" }}>
                      ATHLETES & ADVISORS
                    </h4>
                  </div>
                  <h3 className="h4 text-warning font-weight-700 mb-3" style={{ lineHeight: "1.4" }}>
                    NIL Laws & Regulations
                  </h3>
                  <p className="text-muted mb-4" style={{ fontSize: "0.85rem" }}>
                    Cooperating to sort out NIL laws and regulations as to the use of FHP functions by Athletes.
                  </p>
                  
                  <ListGroup className="list-group-flush">
                    {[
                      "Athlete asks for help from Advisor.",
                      "Advisor contacts the compliance/regulatory authority.",
                      "Advisor states the question and gets official clarification.",
                      "Advisor alerts the Athlete."
                    ].map((step, idx) => (
                      <ListGroupItem key={idx} className="border-0 px-0 py-2 d-flex align-items-start bg-transparent">
                        <i className="fas fa-check-circle text-warning mr-2 mt-1" style={{ fontSize: "13px" }}></i>
                        <span className="text-dark font-weight-500" style={{ fontSize: "0.875rem", lineHeight: "1.4" }}>
                          {step}
                        </span>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </div>
              </CardBody>
            </Card>
          </Col>

        </Row>
      </Container>
    </>
  );
};

export default SharedResponsibility;
